/* global VXConfig */

import PropTypes from 'prop-types';
import PlayButton from '../Base/Preview/PlayButton';

const InterviewTilePlayButton = (props) => <PlayButton show={props.hovering || VXConfig.device.isMobile} />;

InterviewTilePlayButton.propTypes = {
	hovering: PropTypes.bool,
};

export default InterviewTilePlayButton;
